<template>
  <div class="enroll-over">
    <div class="inner">
      <p class="title">恭喜您，您已成功加入神州专车。</p>
    </div>
    <div class="footer">
      <ucar-button size="full" @click="submit">返回首页</ucar-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'enroll-over',
  computed: {
    ...mapGetters([
      'vuexIndexUrl'
    ])
  },
  methods: {
    submit () {
      this.$router.push(this.vuexIndexUrl || '/')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";
.enroll-over {
  flex: 1 0 auto;
  display: flex;
  flex-flow: column nowrap;

  .inner {
    background-color: #fff;
    flex: 1 0 auto;
    padding: 60px $ucar_side_gutter;
    .title {
      font-weight: 700;
      margin-bottom: 30px;
    }
    .error-msg {
      margin-bottom: 30px;
    }
  }
  .footer {
    padding: 30px 0;
  }
}
</style>
